import { toast } from 'react-toastify';

const toastType = toast.TYPE;

export { toast, toastType };

export { default as Message } from './Message';

export { default as ToastContainer } from './ToastContainer';
